/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';
import { getScaledValue } from 'renative';

// react-native-web-linear-gradient renders a View whose style sets
// `backgroundImage: linear-gradient(...)` programmatically (NOT via a CSS
// string), so it is react-native-web-safe: css-to-react-native never has to
// parse a `background-image:` declaration (it cannot, and the attempt crashed
// the SPA on render). Mirrors the gradient-component approach in
// packages/mobile/src/components/LinearGradient.
import LinearGradient from 'react-native-web-linear-gradient';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export const Container = withFocusable({
  trackChildren: true,
})(styled.View.attrs({})`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background-color: #000000;
  font-family: PTSans-Regular;
  flex-direction: row;
  z-index: 3;
  overflow: hidden;
`);

export const ContainerScroll = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: false,
})``;

export const VideoTouch = withFocusable()(styled.View.attrs({})`
  width: 100%;
  height: 100%;
`);

export const ContainerVideo = styled.View.attrs({})`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  ${(props: { wrapped?: boolean; purple?: boolean }) =>
    props.wrapped
      ? `
            flex-direction: row;
        `
      : ``}
  ${(props: { wrapped?: boolean; purple?: boolean }) =>
    props.purple
      ? `
            background-color: #000000; 
            display: flex;
            align-items: center;
            justify-content: center;
        `
      : ``}
    overflow: hidden;
`;

// Left-to-right black fade overlay. The gradient is supplied via the
// component's `colors`/`start`/`end` props (rendered as a programmatic style),
// not a `background-image:` CSS declaration — the latter is unparseable by
// css-to-react-native and crashed the TV SPA on render.
export const VideoDegrade = styled(LinearGradient).attrs({
  colors: ['rgba(0, 0, 0, 0.9)', 'rgba(0, 0, 0, 0.1)'],
  start: { x: 0, y: 0.5 },
  end: { x: 1, y: 0.5 },
})`
  flex: 1;
  width: 100%;
`;

export const VideoContainer = styled.View.attrs({})`
  padding: ${getScaledValue(24)}px 0 0;
  background-color: rgba(53, 36, 93, 0.3);
  flex: 1;
`;

export const VideoContainerPadding = styled.View.attrs({})`
  padding: 0 ${getScaledValue(24)}px;
  flex: 1;
`;
